module.exports = __webpack_public_path__ + "img/address-home.2c910327.svg";